import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import SkeletonTable from "@/components/SkeletonTable"
import { getListJenjangPendidikan } from "@/services/getData"

export default function MasterJenjangPendidikanPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listJenjangPendidikan"],
    queryFn: getListJenjangPendidikan,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
